var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79316 17.2075C7.02748 17.4418 7.40737 17.4418 7.64169 17.2075L17.2069 7.64225C17.4412 7.40794 17.4412 7.02804 17.2069 6.79372C16.9726 6.55941 16.5927 6.55941 16.3584 6.79372L6.79316 16.3589C6.55885 16.5933 6.55885 16.9732 6.79316 17.2075Z",
    fill: "#2C2C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2068 17.2075C16.9725 17.4418 16.5926 17.4418 16.3583 17.2075L6.79309 7.64225C6.55878 7.40794 6.55878 7.02804 6.79309 6.79372C7.02741 6.55941 7.40731 6.55941 7.64162 6.79372L17.2068 16.3589C17.4412 16.5933 17.4412 16.9732 17.2068 17.2075Z",
    fill: "#2C2C2C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClose);
export default __webpack_public_path__ + "static/media/calendar-close.efeb22ff6cf5d4e978228a3272a0ac0d.svg";
export { ForwardRef as ReactComponent };